import React, {createRef, useState} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import __ from "lodash";
import MaterialTable from "@material-table/core";
import {Icon, useTheme} from "@material-ui/core";
import {ColumnWidth } from "../../../blocks/ColumnHelper";
import {defaultComponentsScroll, FullWidthFilter, MaterialTableBody} from "../../../controls/Material-Table-Components";
import TrafficLight from "../../../controls/TrafficLight";
import {useShipmentTracking} from "../../../services/shipmentTracking";
import useDimensions from "../../../blocks/useDimensions";

const bookingStatuses = [
  {code: "BOOKED", value: "Booked"}, {code: "CANCELLED", value: "Cancelled"},
  {code: "DELIVERED", value: "Delivered"}, {code: "FLIGHT-SUMMARY", value: "Summary"},
  {code: "IN-TRANSIT", value: "In Transit"},  {code: "OFFLOAD", value: "Offloaded"},
  {code: "PRE-ADVICE", value: "Pre-Advice"}, {code: "PRE-BOOKING", value: "Pre-Booking"},
  {code: "SPOT", value: "Spot Booked"}, {code: "WAREHOUSE", value: "Received"}];

const ShipmentTrackingList = (_props) => {
  const theme = useTheme();
  const {isAuthenticated} = useAuth0();

  const props = {
    ..._props
  }
  const classes = props.classes;

  const [state, setState] = useState({
    activeRow: null,
    selectedIndex: null
  });

  const handleRowClick = (event, rowData) => {
    setState(
    {
      ...state,
      selectedIndex: rowData.tableData.id
    });
    if (rowData.tableData.id) {
      props.onChangeSelected(rowData);
    }
  }

  const tableRef = createRef({state: {lastEditingRow: false}});

  const queryClient = useQueryClient();
  const extraKeys = [];

  const shipmentTracking = useShipmentTracking({tableRef, queryClient, extraKeys});

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { fontSize:13, padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      filterCellStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
    };

    return [
      /*
        Can use ...ColumnWidth(70) to generate a fixed width column
      */

      {
        ...baseColumn,
        ...ColumnWidth(100),
        title: "AWB",
        field: "awbNo",
        filterComponent: FullWidthFilter
      },
      {
        ...baseColumn,
        ...ColumnWidth(15),
      },
      {
        ...baseColumn,
        ...ColumnWidth(170,2,undefined,{paddingLeft: 10},undefined,undefined,false),
        // cellStyle:{width: "100%"},
        // filterCellStyle:{width: "100%"},
        title: "Booking Status",
        field: "bookingStatus",
        filterComponent: FullWidthFilter,
        render: rowData => {
          return (<div>{ (!rowData.bookingStatus) ? "" : __.find(bookingStatuses, {code: rowData.bookingStatus}).value}</div>);
        },
      },
      {
        ...baseColumn,
        ...(ColumnWidth(55)),
        title: "",
        field: "bookingStatus",
        initialEditValue: "",
        editable: "never",
        filtering: false,
        render: rowData => {
          const now = new Date();
          //const diff = moment.utc(rowData.requestBy).diff(moment(now).utc(), 'days', false);
          return (
            <TrafficLight
              height={16}
              width={40}
              lights={3}
              //status={diff > 2 ? "green" : diff <=0 ? "red": "amber"}
              status={"green"}
              backgroundStyle={{fill: "#f0f0f0"}}
              offStyle={{fill: "#e0e0e0"}}
            />
          );
        },
      },

    ];
  };

  const [tableContainerRef, {height: tableHeight}] = useDimensions({});
  const theader = tableContainerRef.current?.querySelector('thead');
  const thead = theader ? theader.clientHeight : 40;
  const bodyHeight = tableHeight - thead - 10;
  console.log(thead, bodyHeight)

  return (isAuthenticated &&
      <div style={{width: "100%", marginLeft: 20, marginRight: 20}}>
        <div style={{background: "#ffffff", width: "calc(100% - 24px)", paddingTop: 16, paddingLeft: 20, paddingRight: 4}}>
          <div ref={tableContainerRef} className={classes.shipmentTrackingList} style={{width: "100%", minWidth: "100%", height: `calc(100vh - ${props.height + 18}px)`}}>
            <MaterialTable
              icons={{ Filter: React.forwardRef((props, ref) => <Icon className="filterIcon">filter_list</Icon> )}}
              tableRef={tableRef}
              style={{
                border: "none",
                boxShadow: "none",
                borderRadius: 0,
              }}
              onRowClick={handleRowClick}
              options={{
                tableRef,
                highlightRowStyle: {backgroundColor: "#F69259"},
                actionsColumnIndex: -99,
                cellStyle: {
                  padding: "8px 2px",
                },
                headerStyle: {
                  backgroundColor: '#3f3f3f',
                  color: theme.palette.primary.main,
                  padding: 2,
                },
                draggable: false,
                toolbar: false,
                toolbarButtonAlignment: "right",
                pageSize: 10,
                detailPanelType: "single",
                padding: 'dense',
                paging: false,
                filtering: true,
                searchFieldAlignment: "left",
                addRowPosition: "first",
              }}
              components={{
                ...defaultComponentsScroll,
                Body: (props) => (
                  <MaterialTableBody
                    {...props}
                    rowHeight={40}
                    overscanRowCount={10}
                    addVirtualScrolling={true}
                    bodyHeight={bodyHeight>0?bodyHeight:550}
                    headerHeight={thead}
                    filterRowHeight={46}
                  />
                )
              }}
              title="Track & Trace"
              columns={getColumns()}
              data={shipmentTracking.data}
          />
        </div>
      </div>
    </div>
  );

}

export default ShipmentTrackingList;
